import { defineMessages } from 'react-intl';

export const SHOW_TIME_FIELD = 'show_time';

const messages = defineMessages({
  field_show_time: {
    id: 'form_field_show_time',
    defaultMessage: 'Show time selection options',
  },
});

// Extensor de schema para campos do tipo Data/Hora.
export const DateSchemaExtender = (intl) => ({
  fields: [SHOW_TIME_FIELD],
  properties: {
    [SHOW_TIME_FIELD]: {
      title: intl.formatMessage(messages.field_show_time),
      type: 'boolean',
      default: true,
    },
  },
  required: [],
});

export default DateSchemaExtender;
